import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const LightTooltip = ({tooltip_title}) => {

  return(
    <StyleTooltip title={tooltip_title} arrow placement="top">
      <img src={require('../../image/help-circle.jpg')} className='mx-2' height={"19px"} alt='?'/>
    </StyleTooltip>
  )
}

export const StyleTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }}  enterTouchDelay={0}/>
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#033336",
      color: '#fffff',
      boxShadow: theme.shadows[1],
      fontSize: 13,
      fontFamily: "IRANYekanX"
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#033336",
      },
  }));